export default {"src":"/_next/static/media/Ekata_1.d1afc241.svg","height":80,"width":80};